import { render, staticRenderFns } from "./NoDataAvailablePlaceholder.vue?vue&type=template&id=2b331b3a&lang=pug"
import script from "./NoDataAvailablePlaceholder.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoDataAvailablePlaceholder.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports